(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const REVEAL = 'patine-reveal';
  const VISIBLE = 'patine-reveal--visible';

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(VISIBLE);
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -80px 0px', threshold: 0.1 },
  );

  function init(root = document) {
    root.querySelectorAll(`.${REVEAL}:not(.${VISIBLE})`).forEach((el) => observer.observe(el));
  }

  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
